module.exports = __webpack_public_path__ + "static/movie-03-41e27c0422a5b93d82e8fe451706f069.mp4";